var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2629_1117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4039 15.7629L4.78824 0.429871C4.30324 0.150813 3.75311 0.00382444 3.19308 0.00366224C2.63306 0.00350004 2.08284 0.15017 1.59768 0.428947C1.11252 0.707723 0.709491 1.10879 0.429056 1.59189C0.14862 2.07499 0.000649715 2.62311 0 3.18123L0 33.8187C0.000649715 34.3768 0.14862 34.925 0.429056 35.408C0.709491 35.8911 1.11252 36.2922 1.59768 36.571C2.08284 36.8498 2.63306 36.9964 3.19308 36.9963C3.75311 36.9961 4.30324 36.8491 4.78824 36.5701L31.4039 21.2513C31.8841 20.9707 32.2823 20.5698 32.559 20.0884C32.8357 19.607 32.9813 19.0619 32.9813 18.5071C32.9813 17.9524 32.8357 17.4072 32.559 16.9259C32.2823 16.4445 31.8841 16.0436 31.4039 15.7629V15.7629Z",
    fill: "#5ABB7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2629_1117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowLogo);
export default __webpack_public_path__ + "static/media/showLogo.736672f550adacf98d9ea67672d1a815.svg";
export { ForwardRef as ReactComponent };